import axios from "axios";
import { readSessionToken } from "../auth/sessionToken.ts";
import { shouldDestroySession } from "../auth/authErrorContract.ts";

const baseURL = process.env.REACT_APP_API_URL;
//const baseURL = "https://api.chilith.com.mx";

const httpClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(
  async function (config) {
    const token = readSessionToken();

    config.headers = {
      "Content-Type": "application/json",
    };

    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response) {
      const status = error.response.status;
      const url = error.config?.url || "";
      if (shouldDestroySession(status, url)) {
        window.dispatchEvent(new CustomEvent("unauthorized"));
      }
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject({
        status: 500,
        message: "Error de conexión con el servidor.",
      });
    }
  }
);

export default httpClient;

const httpFormDataClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

httpFormDataClient.interceptors.request.use(
  function (config) {
    config.headers = {
      "Content-Type": "multipart/form-data",
    };

    const token = readSessionToken();

    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export { httpFormDataClient };
